import axios from 'axios';
import { isDemoUser, getDemoUrl } from './demoConfig';

// Attach the signed access token to every request so the API verifies identity
// server-side (replaces the old "trust the userid in the body" model). One place
// covers every axios call in the app.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// CSV / file-export endpoints use the native fetch() API, which the axios
// interceptor above does not touch. Wrap fetch once so those calls also carry
// the bearer token. Scoped to our API host; leaves the caller's own
// Authorization header (if any) intact.
if (typeof window !== 'undefined' && window.fetch) {
  const _origFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const token = localStorage.getItem('accessToken');
    if (token && url.indexOf('/reports/api/v1') !== -1) {
      const headers = new Headers(init.headers || (typeof input !== 'string' && input.headers) || {});
      if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
      init = { ...init, headers };
    }
    return _origFetch(input, init);
  };
}

// Intercept all axios requests: rewrite URLs for demo user OR admin viewing DEMO supplier
axios.interceptors.request.use((config) => {
  const isDemo = isDemoUser() ||
    (config.data && typeof config.data === 'object' && config.data.supplier === 'DEMO');
  if (isDemo && config.url) {
    if (
      config.url.includes('/rep_sales/') ||
      config.url.includes('/rep_strikeRate/') ||
      config.url.includes('/rep_ranging/') ||
      config.url.includes('/rep_margin/')
    ) {
      config.url = getDemoUrl(config.url);
    }
  }
  return config;
});
